var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        { staticClass: "akl" },
        [
          _c("div", { staticClass: "bod-view-txt" }, [
            _c(
              "div",
              { staticClass: "os_noticeRes" },
              [
                _c("WasteGlassBottleHeader"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "contBoxWrap padTL padBL",
                    staticStyle: { "background-color": "#ebebeb" }
                  },
                  [
                    _c("WasteGlassApply", {
                      attrs: { abcLocale: _vm.abcLocale, agrees: _vm.agrees },
                      on: {
                        clickapply: _vm.apply,
                        changeagree: _vm.agree,
                        changelocale: _vm.locale
                      }
                    }),
                    _vm._v(" "),
                    _c("WasteGlassBottleFooter")
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("WasteGlassBottlePopupApply"),
          _vm._v(" "),
          _c("WasteGlassBottlePopupClosing"),
          _vm._v(" "),
          _c("WasteGlassBottlePopupDup"),
          _vm._v(" "),
          _c("WasteGlassBottlePopupUnChecked")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fcf8d06", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fcf8d06","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/waste-glass-bottle2/wasteGlassBottle.vue
// module id = null
// module chunks = 